function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import * as actionTypes from './actionTypes';
const initialState = {
    syncPatientId: null,
    syncHealthData: null,
    authorizationCode: null,
    profile: null,
    fetching: [],
    sending: [],
    errors: []
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.AUTHORIZE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.AUTHORIZE),
                    errors: unregisterAction(state.errors, actionTypes.AUTHORIZE)
                });
            }
        case actionTypes.AUTHORIZE_SUCCESS:
            {
                const { code, storageProvider } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    authorizationCode: {
                        code,
                        storageProvider
                    },
                    sending: unregisterAction(state.sending, actionTypes.AUTHORIZE),
                    errors: registerAction(state.errors, actionTypes.AUTHORIZE)
                });
            }
        case actionTypes.AUTHORIZE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.AUTHORIZE),
                    errors: registerAction(state.errors, actionTypes.AUTHORIZE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.GET_PROFILE_SUCCESS:
            {
                const { profile } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    profile
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_PHI_SET:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_PHI_SET),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_PHI_SET)
                });
            }
        case actionTypes.FETCH_PHI_SET_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_PHI_SET)
                });
            }
        case actionTypes.FETCH_PHI_SET_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_PHI_SET),
                    errors: registerAction(state.errors, actionTypes.FETCH_PHI_SET)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_READINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_READINGS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_READINGS)
                });
            }
        case actionTypes.FETCH_READINGS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_READINGS)
                });
            }
        case actionTypes.FETCH_READINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_READINGS),
                    errors: registerAction(state.errors, actionTypes.FETCH_READINGS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.STORE_READINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.STORE_READINGS),
                    errors: unregisterAction(state.errors, actionTypes.STORE_READINGS)
                });
            }
        case actionTypes.STORE_READINGS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_READINGS)
                });
            }
        case actionTypes.STORE_READINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_READINGS),
                    errors: registerAction(state.errors, actionTypes.STORE_READINGS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.STORE_CGM_READINGS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.STORE_CGM_READINGS),
                    errors: unregisterAction(state.errors, actionTypes.STORE_CGM_READINGS)
                });
            }
        case actionTypes.STORE_CGM_READINGS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_CGM_READINGS)
                });
            }
        case actionTypes.STORE_CGM_READINGS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_CGM_READINGS),
                    errors: registerAction(state.errors, actionTypes.STORE_CGM_READINGS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.STORE_MEASUREMENTS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.STORE_MEASUREMENTS),
                    errors: unregisterAction(state.errors, actionTypes.STORE_MEASUREMENTS)
                });
            }
        case actionTypes.STORE_MEASUREMENTS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_MEASUREMENTS)
                });
            }
        case actionTypes.STORE_MEASUREMENTS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_MEASUREMENTS),
                    errors: registerAction(state.errors, actionTypes.STORE_MEASUREMENTS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.STORE_NOTES:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.STORE_NOTES),
                    errors: unregisterAction(state.errors, actionTypes.STORE_NOTES)
                });
            }
        case actionTypes.STORE_NOTES_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_NOTES)
                });
            }
        case actionTypes.STORE_NOTES_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.STORE_NOTES),
                    errors: registerAction(state.errors, actionTypes.STORE_NOTES)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.REMOVE_NOTE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.REMOVE_NOTE),
                    errors: unregisterAction(state.errors, actionTypes.REMOVE_NOTE)
                });
            }
        case actionTypes.REMOVE_NOTE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REMOVE_NOTE),
                    errors: registerAction(state.errors, actionTypes.REMOVE_NOTE)
                });
            }
        case actionTypes.REMOVE_NOTES_QUEUE_FINISHED:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REMOVE_NOTE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.UPDATE_PHI_SET:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.UPDATE_PHI_SET),
                    errors: unregisterAction(state.errors, actionTypes.UPDATE_PHI_SET)
                });
            }
        case actionTypes.UPDATE_PHI_SET_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_PHI_SET)
                });
            }
        case actionTypes.UPDATE_PHI_SET_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.UPDATE_PHI_SET),
                    errors: registerAction(state.errors, actionTypes.UPDATE_PHI_SET)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SYNC:
            {
                return _object_spread_props(_object_spread({}, state), {
                    syncHealthData: null,
                    fetching: registerAction(state.fetching, actionTypes.SYNC),
                    errors: unregisterAction(state.errors, actionTypes.SYNC)
                });
            }
        case actionTypes.SYNC_SUCCESS:
            {
                const { syncPatientId, syncHealthData } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    syncPatientId,
                    syncHealthData,
                    fetching: unregisterAction(state.fetching, actionTypes.SYNC)
                });
            }
        case actionTypes.SYNC_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.SYNC),
                    errors: registerAction(state.errors, actionTypes.SYNC)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_DUMP:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_DUMP),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_DUMP)
                });
            }
        case actionTypes.FETCH_DUMP_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_DUMP)
                });
            }
        case actionTypes.FETCH_DUMP_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_DUMP),
                    errors: registerAction(state.errors, actionTypes.FETCH_DUMP)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CLEAR_AUTHORIZATION_CODE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    authorizationCode: null,
                    profile: null
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            return state;
    }
}
